import styles from './FormFeedbackWrapper.module.scss'
import LoaderAnimation from './LoaderAnimation'

export default function FormFeedbackWrapper ({ children, doFeedback = true }) {

  return (
    <div className={styles.formFeedbackWrapper}>
      {children}
      {doFeedback && (
        <div className={styles.formFeedbackOverlay}>
          <LoaderAnimation small />
        </div>
      )}
    </div>
  )
}